import { useMemo } from 'react';
import { getMarketState, MarketsConfig, MarketState } from './marketStateUtils';
import { useNonTradingDaysCommon } from './useNonTradingDays';

export function useMarketStateCommon(config: MarketsConfig, mic: string, time: Date, today: Date): MarketState {
  const { getNonTradingDaysByMic } = useNonTradingDaysCommon();
  return useMemo(
    () => getMarketState(config, mic, time, today, getNonTradingDaysByMic(mic) ?? []),
    [config, getNonTradingDaysByMic, mic, time, today],
  );
}
